import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ico_Drawer",
  "use": "ico_Drawer-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"ico_Drawer\">\n    <path data-name=\"Union 3\" d=\"M657 641v-1h16v1zm0-5.5v-1h16v1zm0-5.5v-1h16v1z\" transform=\"translate(-653 -623)\" style=\"stroke:transparent;stroke-miterlimit:10\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol